package com.shadowings.gero.data.lessons.chapter11

import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_la_pazienza_e_finita_1
import gero.composeapp.generated.resources.exp_content_la_pazienza_e_finita_2
import gero.composeapp.generated.resources.exp_content_la_pazienza_e_finita_3
import gero.composeapp.generated.resources.exp_content_la_pazienza_e_finita_4
import gero.composeapp.generated.resources.exp_content_la_pazienza_e_finita_5
import gero.composeapp.generated.resources.exp_content_la_pazienza_e_finita_6
import gero.composeapp.generated.resources.exp_content_la_pazienza_e_finita_7
import gero.composeapp.generated.resources.exp_content_la_pazienza_e_finita_8
import gero.composeapp.generated.resources.exp_title_la_pazienza_e_finita

fun getLaPazienzaEFinitaContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_la_pazienza_e_finita,
            content = Res.string.exp_content_la_pazienza_e_finita_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_pazienza_e_finita,
            content = Res.string.exp_content_la_pazienza_e_finita_2,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_pazienza_e_finita,
            content = Res.string.exp_content_la_pazienza_e_finita_3,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_pazienza_e_finita,
            content = Res.string.exp_content_la_pazienza_e_finita_4,
            face = Faces.Surprised,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_pazienza_e_finita,
            content = Res.string.exp_content_la_pazienza_e_finita_5,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_pazienza_e_finita,
            content = Res.string.exp_content_la_pazienza_e_finita_6,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_pazienza_e_finita,
            content = Res.string.exp_content_la_pazienza_e_finita_7,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_pazienza_e_finita,
            content = Res.string.exp_content_la_pazienza_e_finita_8,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
    )
}

fun getLaPazienzaEFinitaQuizContent(
    verbs: List<Verb>,
    words: List<Word>,
    languageCode: String,
    verbSentences: List<SentenceOptions> = DatabaseRepositoryImpl.verbSentences
): List<IQuizContent> {
    return getRecapFrasiPseudoverbaliQuizContent(
        verbs = verbs,
        words = words,
        languageCode = languageCode,
        verbSentences = verbSentences
    )
}
